'use client';

import { useEffect } from 'react';

import {
  redirectToLoginForUnauthorized,
  shouldRedirectForUnauthorizedApiCall,
} from '@/lib/client-auth';

export function AuthUnauthorizedInterceptor() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const originalFetch = window.fetch.bind(window);
    const interceptedFetch: typeof window.fetch = async (input, init) => {
      const response = await originalFetch(input, init);
      if (shouldRedirectForUnauthorizedApiCall(input, response)) {
        redirectToLoginForUnauthorized();
      }
      return response;
    };

    window.fetch = interceptedFetch;
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
}

